module.exports = __webpack_public_path__ + "img/no-ranking.76ffb16.png";